import type { ColumnOptionsService } from '.';
import { signal } from '@preact/signals-react';
import type { Signal } from '@preact/signals-react';
import type { ColumnOptions } from '@thinkalpha/platform-ws-client/contracts/table.js';
import { injectable } from 'src/features/ioc';

/**
 * Per-widget column options service using Preact signals.
 * Each widget instance gets its own ColumnOptionsService with independent state.
 * Initializes with empty options (same default as before).
 */
@injectable()
export class ColumnOptionsServiceImpl implements ColumnOptionsService {
    options: Signal<Partial<ColumnOptions>> = signal({});

    setOptions(options: Partial<ColumnOptions>): void {
        const newOptions: Partial<ColumnOptions> = { ...this.options.value };

        for (const key of Object.keys(options) as (keyof ColumnOptions)[]) {
            const value = options[key];
            if (value !== undefined) {
                (newOptions as Record<keyof ColumnOptions, unknown>)[key] = value;
            } else {
                delete newOptions[key];
            }
        }

        this.options.value = newOptions;
    }

    clearOptions(): void {
        this.options.value = {};
    }
}
